<template>
  <triviaSessionLobbyComponent />
</template>

<script>
import triviaSessionLobbyComponent from "@/views/trivia/pages/trivia_session/components/trivia_session_lobby_component.vue"
export default {
  name: "triviaSessionLobbyPage",
  components: {
    triviaSessionLobbyComponent
  },
}
</script>
